import React from 'react'
import { i18n } from '../../index'
import { Mutation } from 'react-apollo'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import {
  createThumbableService,
  updateThumbableService,
  fetchThumbableServices,
  fetchStationThumbableServices,
} from './thumbableServiceQueries'
import type { ThumbableService } from './thumbableServiceTypes'
import css from './thumbableServiceForm.css'
const defaultFormData: ThumbableService = {
  id: null,
  name: '',
}

const updateCacheOnUpdate =
  (query: any, fieldName: string, stationId: string | null | undefined) =>
  (cache: any, { data: { updateThumbsUpItem } }: any) => {
    const variables = stationId
      ? {
          stationId,
        }
      : {}
    const data = cache.readQuery({
      query,
      variables,
    })
    cache.writeQuery({
      query,
      variables,
      data: {
        [fieldName]: data[fieldName].map((ts) => {
          return ts.id === updateThumbsUpItem.id ? updateThumbsUpItem : ts
        }),
      },
    })
  }

const updateCacheOnCreate =
  (query: any, fieldName: string, stationId: string | null | undefined) =>
  (cache: any, { data: { createThumbsUpItem } }: any) => {
    const variables = stationId
      ? {
          stationId,
        }
      : {}
    const data = cache.readQuery({
      query,
      variables,
    })
    cache.writeQuery({
      query,
      variables,
      data: {
        [fieldName]: [...data[fieldName], createThumbsUpItem],
      },
    })
  }

type ThumbableServiceFormProps = {
  data: ThumbableService | null | undefined
  stationId?: string
  onSubmit: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
}
type ThumbableServiceFormState = {
  formData: ThumbableService
}

class ThumbableServiceForm extends React.Component<ThumbableServiceFormProps, ThumbableServiceFormState> {
  state: ThumbableServiceFormState = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setStateFromData(data)
    }
  }

  componentDidUpdate(prevProps: ThumbableServiceFormProps) {
    const { data } = this.props

    if (data && JSON.stringify(data) !== JSON.stringify(prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: ThumbableService) => {
    this.setState({
      formData: { ...defaultFormData, ...data },
    })
  }
  onInput = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { stationId } = this.props
    const { id, name } = this.state.formData
    const query = stationId ? fetchStationThumbableServices : fetchThumbableServices
    const fieldName = stationId ? 'stationThumbsUpItems' : 'thumbsUpItems'
    onMutate(
      id
        ? {
            variables: {
              id,
              name,
            },
            update: updateCacheOnUpdate(query, fieldName, stationId),
          }
        : {
            variables: stationId
              ? {
                  name,
                  stationId,
                }
              : {
                  name,
                },
            update: updateCacheOnCreate(query, fieldName, stationId),
          },
    )
    this.props.onSubmit()
    this.onReset()
  }
  onReset = () => {
    this.setState({
      formData: { ...defaultFormData },
    })
  }

  render() {
    const { onCancel } = this.props
    const { formData } = this.state
    return (
      <Mutation mutation={formData.id ? updateThumbableService : createThumbableService}>
        {(onMutate) => (
          <form onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.component}>
            <TextField
              autoFocus
              required
              label={i18n.t('admin.thumbableServices.label.thumbableServiceName')}
              value={formData.name}
              onChange={(e) => this.onInput('name', e.target.value)}
              className={css.textField}
            />
            <DialogActions className={css.actions}>
              <Button type='button' onClick={onCancel}>
                {i18n.t('buttons.cancel')}
              </Button>
              <Button type='submit' color='primary'>
                {i18n.t('buttons.save')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Mutation>
    )
  }
}

export default ThumbableServiceForm
